import React, { useState } from "react";
import CastrolLogo from "../../assets/castrol_partner.jpg";
import HPLogo from "../../assets/hp_partner.jpg";
import ShellLogo from "../../assets/shell_partner.jpg";
import BalmerolLogo from "../../assets/balmerol_partner.jpg";
import MobilLogo from "../../assets/mobil_partner.jpg";
import ValvolineLogo from "../../assets/valvoline_partner.jpg";
import VeedolLogo from "../../assets/veedol_partner.jpg";
import ServoLogo from "../../assets/servo_partner.jpg";
import MakLubricantsLogo from "../../assets/mak_lubricants_partner.jpg";
import "./partners.css";

const Partners = () => {

    const logos = [
        CastrolLogo,
        HPLogo,
        ShellLogo,
        BalmerolLogo,
        MobilLogo,
        ValvolineLogo,
        VeedolLogo,
        ServoLogo,
        MakLubricantsLogo
    ];

    const [ isPaused, setIsPaused ] = useState(false);

    const handleMouseEnter = () => setIsPaused(true);
    const handleMouseLeave = () => setIsPaused(false);

    return (
        <div className="partners-container">
            <div className="partners-heading">
            <h2>20+ Brands</h2>
            <h1>All at One Stop</h1>
            </div>
            <div className={`slider-container ${isPaused ? "paused" : ""}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} >
                {
                    [ ...logos, ...logos ].map((logo, index) => (
                        <div className="slider-item" key={index}>
                            <img className='slider-image' src={logo} alt={`Partner logo ${index}`} />
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default Partners;